import { Pipe } from "@angular/core";

@Pipe({ name: "prefix" })
export class PrefixPipe {
    transform(valor: any, prefixo: string): string {
        if (!valor || (valor.length && valor.length <= 0)) {
            return "";
        }

        return `${prefixo}${valor}`;
    }
}
